import { ComponentModelDTO, ComponentType } from "groopit-js/client";

export const getComponentName = (type: ComponentType) => {
  switch (type) {
    case ComponentType.Picture:
      return "Photo";
    case ComponentType.PictureSet:
      return "Photos";
    case ComponentType.Location:
      return "Location";
    case ComponentType.Note:
      return "Text";
    case ComponentType.MultipleChoice:
      return "Tags";
    case ComponentType.DateTime:
      return "Date";
    case ComponentType.MultipleChoiceExtended:
      return "List";
    case ComponentType.FixedDecimal:
      return "Numbers";
    case ComponentType.Table:
      return "Table";
    case ComponentType.FileSet:
      return "Files";
    case ComponentType.SaveToSalesforce:
      return "Salesforce";
    case ComponentType.FollowUpRequest:
      return "Follow-up";
    default:
      throw new Error("Unimplemented component type name: " + type);
  }
};

export const getComponentIcon = (type: ComponentType) => {
  switch (type) {
    case ComponentType.Picture:
      return "/Content/Images/ic_add_photo.png";
    case ComponentType.PictureSet:
      return "/Content/Images/ic_photoset.png";
    case ComponentType.Location:
      return "/Content/Images/ic_location.png";
    case ComponentType.Note:
      return "/Content/Images/ic_notes.png";
    case ComponentType.MultipleChoice:
      return "/Content/Images/ic_tag.png";
    case ComponentType.DateTime:
      return "/Content/Images/ic_datetime.png";
    case ComponentType.MultipleChoiceExtended:
      return "/Content/Images/ic_list.png";
    case ComponentType.FixedDecimal:
      return "/Content/Images/ic_number.png";
    case ComponentType.Table:
      return "/Content/Images/ic_table.png";
    case ComponentType.FileSet:
      return "/Content/Images/ic_files.png";
    case ComponentType.SaveToSalesforce:
      return "/Content/Images/ic_save_to_salesforce.png";
    case ComponentType.InheritedData:
      return null;
    case ComponentType.FollowUpRequest:
      return "/Content/Images/ic_notresponded.png";
    default:
      throw new Error("Unimplemented component type icon: " + type);
  }
};

export const getComponentDescriptionPlaceholder = (type: ComponentType) => {
  switch (type) {
    case ComponentType.SaveToSalesforce:
      return "Save to Salesforce";
    case ComponentType.FollowUpRequest:
      return "Immediate follow-up required";
    case ComponentType.Table:
      return "Table description";
    default:
      return "Prompt";
  }
};

const getDefaultComponentDescription = (type: ComponentType) => {
  switch (type) {
    case ComponentType.SaveToSalesforce:
      return "Save to Salesforce";
    case ComponentType.FollowUpRequest:
      return "Immediate follow-up required";
    default:
      return "";
  }
};

export const getDefaultComponent = (
  id: number,
  type: ComponentType,
  sequence: number,
  parentComponentModelId?: number,
) => {
  const newComponent = new ComponentModelDTO({
    componentModel_Id: id,
    type: type,
    sequence: sequence,
    description: getDefaultComponentDescription(type),
    required: false,
    formId: "", // This doesn't matter. We populate it on save,
    hiddenFromMembers: false,
    isFlagField: false,
    isFollowUpField: false,
    parentModelComponentModel_Id: parentComponentModelId,
  });

  switch (type) {
    case ComponentType.MultipleChoice:
      newComponent.multiple = false;
      newComponent.userEditable = false;
      break;
    case ComponentType.MultipleChoiceExtended:
      newComponent.multiple = false;
      break;
    case ComponentType.DateTime:
      newComponent.dateOnly = true;
      break;
  }

  return newComponent;
};
